import { useQuery } from '@tanstack/react-query';
import { getReferralConfig } from '../../../../../services/loyalty';

export function getFindLoyaltyUserByIdQueryOptions() {
  return {
    queryKey: ['referral-config'],
    queryFn: () => getReferralConfig(),
  };
}

export default function useGetReferralConfig() {
  return useQuery(getFindLoyaltyUserByIdQueryOptions());
}
